<template>
    <div class="container">
        <div class="card-item">
            <div class="card-title">
                <p v-for="(item,index) in tabList" :key="index" @click="tabToggle(index)" :class="{active:index === sel}">{{item}}</p>
            </div>
            <div class="card-content">
                <enterpriseFinance v-if="sel == 0"/>
                <enterpriseSecurity v-if="sel == 1"/>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import enterpriseFinance from './main-security-child/enterprise-finance-from'
    import enterpriseSecurity from './main-security-child/enterprise-security-from'
    export default {
        name: "main-security-form",
        components:{
            enterpriseFinance,
            enterpriseSecurity
        },
        data() {
            return {
                tabList: ['企业财税信息', '企业社保信息'],
                sel: 0,
            }
        },
        computed: {
            ...mapState({
                id: (state) => state.user.orgId,
                entId: (state) => state.user.userinfo.userId
            })
        },

        methods: {
            tabToggle (index) {
                this.sel = index;
            }
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-textarea__inner {
        width: 910px;
        height: 80px;
    }
    .container{
        .card-item{
            .card-title{
                cursor: pointer;
                display: flex;
                align-items: center;
                p{
                    font-size: 16px;
                    margin: 0 32px;
                }
                .active{
                    color: #1890FF;
                    border-bottom: 2px solid #1890FF;
                    margin-bottom: 2px;
                }
            }
        }
    }
</style>